module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"50","height":"50","viewBox":"0 0 50 50"},"content":"<path class='channel-icon-logo' fill=\"#EF790C\" fill-rule=\"evenodd\" d=\"M7.433 7H46L28.262 32.527H44.1V43H4l20.829-26.182H7.433z\"/>"}


//////////////////
// WEBPACK FOOTER
// ./client/components/Icon/images/channel/zanox.svg
// module id = 1382
// module chunks = 0